import { enumObjectTypes } from "../constants";
import { Div2Floor } from "../utils/Div2Floor";
import { GetObjectRecordID } from "../utils/GetObjectRecordID";

/**
 * @typedef {import('./QPageNode').QPageNode} QPageNode
 */

export class QNodeArray extends Array {
  constructor(...args) {
    super(...args);
    this.fIsIndexed = false;
  }

  SetIsIndexed(isIndexed) {
    this.fIsIndexed = isIndexed;

    if (isIndexed) this.ReIndex();
  }

  AddNode(aNode) {
    if (this.fIsIndexed == false) {
      this.push(aNode);
      return;
    }

    var dbObjID = aNode.fDataObjID; // aNode.fDataObj.GetObjectID();

    var n = this.length;
    for (var i = n - 1; i >= 0; i--) {
      var tObjID = this[i].fDataObjID;
      if (tObjID < dbObjID) {
        this.splice(i + 1, 0, aNode);
        return;
      }
    }

    this.splice(0, 0, aNode);
  }

  LinearSearch(objID) {
    var n = this.length;
    for (var i = 0; i < n; i++) {
      var t = this[i];
      if (t.fDataObjID == objID) return t;
    }

    return null;
  }

  /**
   * @param {number} objID
   * @returns {(QPageNode | null)}
   */
  FindNodeFromDataObjID(objID) {
    if (this.fIsIndexed == false) return this.LinearSearch(objID);

    var low = 0,
      high = this.length - 1,
      i,
      t;
    while (low <= high) {
      //i = Math.floor((low + high) / 2);
      var i = Div2Floor(low + high);
      var t = this[i];
      if (t.fDataObjID < objID) {
        low = i + 1;
        continue;
      }
      if (t.fDataObjID > objID) {
        high = i - 1;
        continue;
      }
      return t;
    }

    return null;
  }

  FindNodeFromBox(aBox) {
    var n = this.length;
    for (var i = 0; i < n; i++) {
      var aNode = this[i];
      if (aBox == aNode.GetChartBox()) return aNode;
    }

    return null;
  }

  ReIndex() {
    var oldList = [];
    while (this.length > 0) {
      var p = this.pop();
      oldList.push(p);
    }

    var n = oldList.length;
    for (var i = 0; i < n; i++) {
      this.AddNode(oldList[i]);
    }
  }

  FindNodeFromRecordID(recordID, objType = null) {
    for (var i = 0; i < this.length; i++) {
      var t = this[i];
      var dataObj = t.GetDataObj();
      if (dataObj != null) {
        var objObjType = dataObj.InferObjectType();
        if (objType && objObjType != objType) continue;

        var objRecordID = dataObj.GetObjectRecordID();
        if (objRecordID == recordID) return t;
      }
    }

    return null;
  }

  ReturnFlatList() {
    var copyArray = this.slice(0); //??Where did the indexed property go?
    return copyArray;
  }
}
